import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Routes } from "react-router-dom";
import './styles/professional.css';


import AdminUsers from "./Admin/Adminpass";
import AdvancedAnalytics from "./Admin/AdvancedAnalytics";
import ApprovedRegistrations from "./Admin/ApprovedRegistrations";
import DashboardView from "./Admin/Dashboarddata";
import EditApproval from "./Admin/EditApproval";
import EditNews from "./Admin/EditNews";
import EmployeeDashboard from "./Admin/employeedash";
import Home from "./Admin/Home";
import Amain from "./Admin/Amain";
import JatiPrakar from "./Admin/JatiPrakar_updated";
import LoginSelect from "./Admin/Loginselect";
import Masters from "./Admin/Masters";
import MastersData from "./Admin/Mastersdata";
import OtherMasters from "./Admin/Othermasters";
import PendingApprovals from "./Admin/PendingApprovals";
import Registrationdata from "./Admin/Registrationdata";
import RejectedRegistrations from "./Admin/RejectedRegistrations";
import Requests from "./Admin/Requests";
import WorkMaster from "./Admin/WorkMaster";
import AdminLayout from "./AdminLayout";
import AddMember from "./info/AddMember";
import Information from "./info/Information";
import InformationPage from "./info/InformationPage";
import RegistrationForm from "./info/Registration";
import Search from "./info/Search";
import Layout from "./Layout";
import Uddeshya from './Main/Uddeshya';
import About from "./Main/About";
import ComingSoon from "./Main/ComingSoon";
import Contact from "./Main/Contact";
import Front from "./Main/Front";
import Login from "./Main/Login";
import ParivarCard from "./Main/ParivarCard";
import ParivarCardLayout from "./Main/ParivarCardLayout";
import VishishtForm from "./vishisht/VishishtForm";
import VishishtPublic from "./vishisht/VishishtPublic";
import VishishtAdmin from "./Admin/VishishtAdmin";
import TeamAdmin from "./Admin/TeamAdmin";

const App = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Front />} />
        <Route path="/Registration" element={<RegistrationForm />} />
        <Route path="/information/:regId" element={<Information />} />
        <Route path="/information" element={<InformationPage />} />
        <Route path="/Search" element={<Search />} />
        <Route path="/add-member" element={<AddMember />} />
        <Route path="/parivar-card" element={<ParivarCard />} />
        <Route path="/parivar-card-layout" element={<ParivarCardLayout />} />
        <Route path="/login" element={<Login/>} />
        <Route path="/coming-soon" element={<ComingSoon />} />
        <Route path="/about" element={<About />} />
        <Route path="/uddeshya" element={<Uddeshya />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/vishisht-panjikaran" element={<VishishtForm />} />
        <Route path="/vishisht" element={<VishishtPublic />} />
      </Route>
      <Route path="/Select-login" element={<LoginSelect/>} />{/*  */}
      <Route element={<AdminLayout />}>
                                 
<Route path="/Amain" element={<Amain/>} />
<Route path="/edit-approval" element={<EditApproval/>} />
<Route path="/requests" element={<Requests/>} />
<Route path="/pending-approvals" element={<PendingApprovals/>} />
<Route path="/Registrationdata" element={<Registrationdata/>} />
<Route path="/approved-registrations" element={<ApprovedRegistrations/>} />
<Route path="/rejected-registrations" element={<RejectedRegistrations/>} />
<Route path="/advanced-analytics" element={<AdvancedAnalytics/>} />
<Route path="/Location" element={<Masters/>} />
<Route path="/jati-prakar" element={<JatiPrakar/>} />
<Route path="/work-master" element={<WorkMaster/>} />
<Route path="/edit-news" element={<EditNews/>} />
<Route path="/othermasters" element={<OtherMasters/>} />
<Route path="/Mastersdata" element={<MastersData/>} />
<Route path="/Adminpass" element={<AdminUsers/>} />
<Route path="/employee-dashboard" element={<EmployeeDashboard/>} />
<Route path="/dashboard-view" element={<DashboardView/>} />
<Route path="/admin-parivar-card" element={<ParivarCard/>} />
<Route path="/vishisht-admin" element={<VishishtAdmin/>} />
<Route path="/team-admin" element={<TeamAdmin/>} />








      </Route>
    </Routes>
  );
};

export default App;
